// logout.component.ts
import { Component } from '@angular/core';
import { MsalService } from '@azure/msal-angular';

@Component({
  selector: 'app-logout',
  template: `<p>Failed...</p>`,
  standalone:true
})
export class LoginFailedComponent {
  constructor(private msalService: MsalService) {}

  
}
